import BaseFoundation from '../base/foundation';
export default class ScrollListFoundation extends BaseFoundation {}